import InfoWrapper from '../../modules/common/SectionInfo'
import {SubmitHandler, useForm} from 'react-hook-form'
import {SHOW_SUCCESS} from '../../../util'
import {useNavigate} from 'react-router-dom'
import {useAppDispatch} from '../../store'
import {addTransactionAction} from '../../reducers/transactionsReducer'
import {useEffect, useState} from 'react'

interface FormFields {
  type: string
  description: string
  isActive: 0 | 1
  isConvenienceFee: 0 | 1
  convenienceFee: number
}

const CreateTransaction = () => {
  const {
    register: submit,
    handleSubmit: handleSubmitForm,
    formState: {errors},
    watch,
  } = useForm<FormFields>({
    defaultValues: {
      type: '',
      description: '',
      isActive: 0,
      isConvenienceFee: 1,
      convenienceFee: 3,
    },
  })

  const navigate = useNavigate()
  const dispatch: any = useAppDispatch()

  const [check, setCheck] = useState(0)
  const [convenienceCheck, setConvenienceCheck] = useState(1)
  const [convenienceFee, setConvenienceFee] = useState<string>('3')
  const [convenienceError, setConvenienceError] = useState('')
  const convenienceFeePattern = /^\d{0,2}(\.\d{0,2})?$/

  const selectedType = watch('type')

  useEffect(() => {
    if (selectedType !== 't') {
      setConvenienceError('')
    }
  }, [selectedType])

  const onSubmit: SubmitHandler<FormFields> = (rData: any) => {
    const isFeeType = rData.type === 't'
    const feeValue = Number(convenienceFee)

    if (
      isFeeType &&
      convenienceCheck === 1 &&
      (!convenienceFee || feeValue <= 0 || feeValue > 99.99)
    ) {
      setConvenienceError('Convenience fee must be a positive, non-zero value')
      return
    }

    const finalData = {
      ...rData,
      isActive: check,
      isConvenienceFee: isFeeType ? convenienceCheck : 0,
      convenienceFee: isFeeType && convenienceCheck === 1 ? feeValue : 0,
    }
    dispatch(addTransactionAction({data: finalData, navigate, SHOW_SUCCESS}))
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Create Transaction</h3>
        </div>
      </div>
      <form className='form' onSubmit={handleSubmitForm(onSubmit)}>
        <div className='card-body border-top px-9 pb-9 pt-0'>
          <InfoWrapper>
            <div className='row'>
              <div className=''>
                <label className='col-form-label required fw-bold fs-6'>Type</label>
                <select
                  {...submit('type', {required: 'Type is required'})}
                  className='form-select form-select-lg form-select-solid'
                >
                  <option value=''>Select Type</option>
                  <option value='r'>Refund</option>
                  <option value='t'>Fee</option>
                  <option value='d'>Discount</option>
                </select>
                {errors.type?.type && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{errors.type?.message}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className=''>
                <label className='col-form-label fw-bold fs-6'>
                  <span className='required'>Description</span>
                </label>
                <textarea
                  {...submit('description', {required: 'Description is required'})}
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Description'
                />
                {errors.description?.type && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{errors.description?.message}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className='d-flex align-items-center'>
                <input
                  {...submit('isActive')}
                  type='checkbox'
                  className='form-check-input form-check-solid'
                  onChange={(e) => setCheck(e.target.checked ? 1 : 0)}
                />
                <label className='col-form-label fw-bold fs-6 ms-3'>
                  <span className='required'>isActive</span>
                </label>
                {/* {errors.isActive?.type && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{errors.isActive?.message}</span>
                    </div>
                  </div>
                )} */}
              </div>
              {selectedType === 't' && (
                <>
                  <div className='d-flex align-items-center mt-4'>
                    <input
                      type='checkbox'
                      className='form-check-input form-check-solid'
                      checked={convenienceCheck === 1}
                      onChange={(e) => {
                        const checked = e.target.checked ? 1 : 0
                        setConvenienceCheck(checked)
                        if (checked === 1 && (!convenienceFee || Number(convenienceFee) <= 0)) {
                          setConvenienceFee('3')
                        }
                        setConvenienceError('')
                      }}
                    />
                    <label className='col-form-label fw-bold fs-6 ms-3'>
                      Card Convenience Fee
                    </label>
                  </div>
                  {convenienceCheck === 1 && (
                    <div className='mt-3'>
                      <label className='col-form-label fw-bold fs-6'>
                        <span className='required'>Convenience Fee (%)</span>
                      </label>
                      <input
                        type='text'
                        inputMode='decimal'
                        placeholder='0.00'
                        className='form-control form-control-lg form-control-solid'
                        value={convenienceFee}
                        onChange={(e) => {
                          const raw = e.target.value
                          if (raw !== '' && !convenienceFeePattern.test(raw)) return
                          setConvenienceFee(raw)
                          const num = Number(raw)
                          if (raw === '' || num <= 0 || num > 99.99) {
                            setConvenienceError(
                              'Convenience fee must be a positive, non-zero value'
                            )
                          } else {
                            setConvenienceError('')
                          }
                        }}
                      />
                      {convenienceError && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>
                            <span role='alert'>{convenienceError}</span>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </InfoWrapper>
        </div>
        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button type='submit' className='btn btn-primary'>
            Save
          </button>
        </div>
      </form>
    </div>
  )
}

export default CreateTransaction
